import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useNavigationType
} from 'react-router-dom';
import Navbar from './components/Navbar';
import './App.css'; // Global styles    

// Lazy load pages
const Home = React.lazy(() => import('./pages/Home'));
const GalleryPage = React.lazy(() => import('./pages/GalleryPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));

// Scroll restoration component
function ScrollToTop() {
  const navigationType = useNavigationType();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [navigate.location, navigationType]);

  return null;
}

// Error Boundary Component
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("React component error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2em', textAlign: 'center' }}>
          <h2>Kļūda ielādējot šo sadaļu</h2>
          <p>Lūdzu pārlādējiet lapu</p>
          <button onClick={() => window.location.reload()}>Pārlādēt</button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Main App Component
function App() {
  return (
    <Router>
      <ScrollToTop />
      <ErrorBoundary>
        <Suspense fallback="Ielādē lappusi...">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

export default App;